import { useContext } from "react";

import { LLMEventContext } from "../../contexts/user/LLMEventContext";

const useLLMEvent = () => {
  const context = useContext(LLMEventContext);

  if (!context) throw new Error("LLMEventContext must be placed within LLMEventProvider");

  return context;
};

export default useLLMEvent;
